import { createAuthenticator, fetch } from 'redux-simple-auth';

export default createAuthenticator({
  name: 'user',
  restore: data => new Promise(resolve => resolve(data)),
  authenticate: async token => {
    const { default: store } = await import('../config/store');
    const response = await store.dispatch(
      fetch(`${process.env.REACT_APP_API_URL}/api/tokens/authorize`, {
        method: 'POST',
        body: JSON.stringify({ token: token.access_token }),
        headers: {
          'Content-Type': 'application/json'
        }
      })
    );

    if (!response.ok) {
      return Promise.reject(new Error(JSON.stringify(response)));
    }

    return response.json()
  }
});



// WEBPACK FOOTER //
// ./src/authenticators/user.js